import type { ListingSummary } from '@/lib/feedbridge/types'
import { ListingCard } from './ListingCard'
import { Reveal } from '@/components/Reveal'

interface ListingGridProps {
  listings: ListingSummary[]
  featuresMap?: Record<string, Record<string, unknown>>
  underOfferMap?: Record<string, boolean>
  thumbnailMap?: Record<string, string>
  thumbnailsMap?: Record<string, string[]>
  inspectionTimesMap?: Record<string, string>
}

export function ListingGrid({
  listings,
  featuresMap,
  underOfferMap,
  thumbnailMap,
  thumbnailsMap,
  inspectionTimesMap,
}: ListingGridProps) {
  if (!listings.length) {
    return (
      <div className="py-16 text-center">
        {/* theme/muted-foreground — was a hardcoded #8f8f8f, which is a Figma *wireframe*
            colour and not part of the token set. */}
        <p className="text-muted-foreground text-body-md font-normal">
          No properties to show right now.
        </p>
      </div>
    )
  }

  return (
    // Figma card grid — gaps are RESPONSIVE, not a flat 64px:
    //   mobile  390 (4022:100117): 1 col, row gap 48 (gap/gap-12)
    //   tablet  768: 2 cols x 336, column gap 32, ROW gap 64
    //   desktop 1600 (4022:82067): 3 cols, gap 64 both axes (gap/gap-16)
    // A flat gap-16 made tablet cards 320px (16px too narrow) with a doubled gutter, and
    // added 16px of extra pitch per row on mobile.
    <div className="grid grid-cols-1 gap-y-12 md:grid-cols-2 md:gap-x-8 md:gap-y-16 lg:grid-cols-3 lg:gap-16">
      {listings.map((listing, index) => (
        // Stagger by position within the row (max 3 columns), not the flat
        // list index — otherwise cards far down a long grid would sit and
        // wait out an ever-growing delay after they've already scrolled into view.
        <Reveal key={listing.id} variant="slideup" delay={(index % 3) * 100}>
          <ListingCard
            listing={listing}
            features={featuresMap?.[listing.external_listing_id]}
            underOffer={underOfferMap?.[listing.external_listing_id]}
            thumbnailUrl={thumbnailMap?.[listing.external_listing_id]}
            thumbnailUrls={thumbnailsMap?.[listing.external_listing_id]}
            inspectionTime={inspectionTimesMap?.[listing.external_listing_id]}
          />
        </Reveal>
      ))}
    </div>
  )
}
